import { useState } from "react";
import { useHistory } from "react-router-dom";
import "./login.css";
import spinner from "./spinner4.svg";
import logo from "./logo.png";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import "../../utils/i18n/i18n_login";
import { ACCESS_TOKEN } from "../../utils/const/string-const";
import { verifyLogin } from "../../api/api-usuario-web";

export default function Login() {
  const { t, i18n } = useTranslation();
  const [usuario, setUsuario] = useState("");
  const [contrasenia, setContrasenia] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const history = useHistory();

  const submit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const response = await verifyLogin(usuario, contrasenia);
      // console.log('response');
      // console.log(response);
      setLoading(false);

      if (response.error === false) {
        localStorage.setItem(ACCESS_TOKEN, response.body.token);
        history.push(`/dashboard`);
      } else {
        alert('Usuario o contraseña incorrecto');
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="login-container">
      <form onSubmit={submit} className="login-form">
        <div className="login-box">
          <img id="logo" src={logo} alt="Logo" className="login-logo" />
          <h2 className="title">{t("title")}</h2>

          {/* Language Dropdown */}
          <div className="language-selector">
            <label htmlFor="language">{t("language")}:</label>
            <select
              id="language"
              onChange={(e) => changeLanguage(e.target.value)}
              defaultValue={i18n.language} // Set default based on i18n's current language
            >
              <option value="en">English</option>
              <option value="es">Español</option>
            </select>
          </div>
          <br />
          <div className="input-fields">
            <div className="field">
              <label htmlFor="usuario_login" className="field-label">{t("username")}:</label>
              <input
                id="usuario_login"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                className="login-input"
                type="text"
                placeholder={t("username")}
              />
            </div>

            <div className="field">
              <label htmlFor="password_login" className="field-label">{t("password")}:</label>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <input
                  id="password_login"
                  value={contrasenia}
                  onChange={(e) => setContrasenia(e.target.value)}
                  className="login-input"
                  type={passwordVisible ? "text" : "password"}
                  placeholder={t("password")}
                />
                <div
                  className="password-toggle"
                  onClick={() => setPasswordVisible(!passwordVisible)}
                >
                  {passwordVisible ? (
                    <EyeSlashIcon className="password-icon" width={25} />
                  ) : (
                    <EyeIcon className="password-icon" width={25} />
                  )}
                </div>
              </div>
            </div>

            <div className="field bg-[#000D39] flex justify-center text-white p-2 rounded-md">
              {loading === false &&
                <button type="onSubmit" className="login_button">
                  {t("login")}
                </button>
              }
              {loading === true &&
                <button className="login_button flex justify-center">
                  <img className="spinner" alt="spinner" src={spinner} />
                </button>}
            </div>
          </div>

          {/* <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <ArrowLeftCircleIcon
              width={24}
              color="#0F3457"
              className="back-button"
              onClick={() => history.push(`/landing`)}
            />

          </div> */}

          <div className="version">{t("version")}</div>
        </div>
      </form>
    </div>
  );
}
